import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { Form } from "@shared/components";

export function IntegrationsStep() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Select
          name="integration_id"
          label={translate("flux.fields.integration_id")}
          options={[]}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="is_default_agreement"
          label={translate("flux.fields.is_default_agreement")}
          instructions={translate("flux.instructions.is_default_agreement")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="can_use_dataless_integration"
          label={translate("flux.fields.can_use_dataless_integration")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="third_party_login"
          label={translate("flux.fields.third_party_login")}
        />
      </Grid>
    </Grid>
  );
}
